export default "__VITE_ASSET__NYvwOIUT__"